import { Box, Breadcrumbs, Link, Skeleton, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export type IAnalyticsPageHeaderBreadcrumb = {
  label: React.ReactNode;
  link?: string;
};

type IAnalyticsPageHeaderProperties = {
  breadcrumbs: IAnalyticsPageHeaderBreadcrumb[];
  actions?: React.ReactNode;
  isFetching?: boolean;
};

export const AnalyticsPageHeader = observer(({ breadcrumbs, actions, isFetching }: IAnalyticsPageHeaderProperties) => {
  const shouldRenderBreadcrumbs = isFetching !== undefined || breadcrumbs.length > 1;
  const fontSize = shouldRenderBreadcrumbs ? 24 : 48;
  const renderedBreadcrumbs = isFetching
    ? [
        ...breadcrumbs,
        {
          label: <Skeleton variant="text" width={180} />,
        },
      ]
    : breadcrumbs;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        {!shouldRenderBreadcrumbs ? (
          <Typography sx={{ fontSize, lineHeight: 1.2 }}>{breadcrumbs[0].label}</Typography>
        ) : (
          <Breadcrumbs>
            {renderedBreadcrumbs.map((breadcrumb, index) => {
              if (breadcrumb.link) {
                return (
                  <Link
                    key={`${index}-${breadcrumb.link}`}
                    component={RouterLink}
                    to={breadcrumb.link}
                    underline="hover"
                    color="inherit"
                    sx={{ fontSize, lineHeight: 1.2 }}
                  >
                    {breadcrumb.label}
                  </Link>
                );
              }

              return (
                <Typography key={index} sx={{ fontSize, lineHeight: 1.2 }}>
                  {breadcrumb.label}
                </Typography>
              );
            })}
          </Breadcrumbs>
        )}
      </Box>
      {actions ? <Box sx={{ flexShrink: 0 }}>{actions}</Box> : null}
    </Box>
  );
});
